import { DataService, ApiService, AuthService } from "@/service";
import { Category, WinForm } from "@/libs";
export class UserService {
	//获取当前用户数据
	static user() {
		return AuthService.user();
	}
	// 当前登录的企业id
	static compId() {
		return UserService.user().CompID;
	}
	// 当前登录账户是否是企业
	static isComp() {
		return Boolean(Number(this.compId()));
	}
	static userID() {
		return UserService.user().UserID || UserService.user().UserId;
	}

	static isShowPhone() {
		return WinForm.storge.get("isShowPhone") || UserService.user().IsShowPhone;
	}
	static setIsShowPhone(value: string) {
		return WinForm.storge.set("isShowPhone", value);
	}

	// 更新本地用户信息
	static updateLocalUserInfo(key: string, value: any) {}

	// 是否为SVip
	static isSVip(): any {
		return (UserService.user().UserVipLevel & 2) == 2 || (UserService.user().UserVipLevel & 4) == 4;
	}

	// 我下载的产品
	// @ts-ignore
	static async downProdLogsForUser(page: number, pageSize) {
		return await DataService.get(`${ApiService.JrzzApi80}/logs/DownProdLogsForUser?page=${page}&pageSize=${pageSize}`);
	}
	// 我浏览过的产品
	// @ts-ignore
	static async viewProdLogsForUser(page: number, pageSize) {
		return await DataService.get(`${ApiService.JrzzApi80}/logs/ViewProdLogsForUser?page=${page}&pageSize=${pageSize}`);
	}
	// 我浏览过的公司
	// @ts-ignore
	static async viewCompLogsForUser(page: number, pageSize) {
		return await DataService.get(`${ApiService.JrzzApi80}/logs/ViewCompLogsForUser?page=${page}&pageSize=${pageSize}`);
	}

	// 记录用户浏览日志
	static viewLogs(type: "Comp" | "Prod", id: string) {
		if (!id) return;
		let prodViewUrl = `${ApiService.JrzzApi}/views/${Category[type]}/${id}.jpg?token=${encodeURIComponent(AuthService.token(false))}`;
		let imgDom = document.createElement("img");
		imgDom.src = prodViewUrl;
		imgDom.style.display = "none";
		document.body.appendChild(imgDom);
	}

	// 用户描述Tag
	static async listUserLabel(userType: any) {
		return await DataService.get(`${ApiService.EngineerApi}/madeToday/listUserLabel`, { userType });
	}

	// 保存用户描述
	static async SaveDescription(data: any) {
		return await DataService.post(`${ApiService.EngineerApi}/madeToday/SaveDescription`, data);
	}

	// 保存用户描述
	static async infoDescription() {
		return await DataService.get(`${ApiService.EngineerApi}/madeToday/infoDescription`);
	}

	static async setData(key:string, value: string, timeout = 604800) {
		return await DataService.post(`${ApiService.EngineerApi}/user/setData`, {
			key,
			value,
			timeout,
		});
	}

	/**
	 * 获取临时数据
	 * @returns 
	 */
	static async getData(key: string) {
		return await DataService.get(`${ApiService.EngineerApi}/share/getData?key=${key}`);
	}

	/**
	 * 航天云网第三方登录，登录类型为6
	 * @param code 
	 * @param scope 
	 * @returns 
	 */
	static async casiLogin(code: string, scope: string = '') {
		return await DataService.get(`${ApiService.JrzzApi80}/casi/login?code=${code}&scope=${scope}`);
	}

	/**
	 * token获取登录信息（和登录接口字段一样）
	 * @param token 
	 * @returns 
	 */
	static async GetTokenUserInfo(token: string) {
		return await DataService.get(`${ApiService.JrzzApi}/user/GetTokenUserInfo?Token=${token}`);
	}

	/**
	 * 判断用户是否能下载未签约企业模型
	 * @returns 
	 */
	static async isDownload(prodId: string) {
		if(prodId) {
			return await DataService.get(`${ApiService.EngineerApi}/user/isDownload`, {prodId}, { noShowErr: true });
		}
		return await DataService.get(`${ApiService.EngineerApi}/user/isDownload`, {}, { noShowErr: true });
	}

	static async isOrderMember() {
		const userId = this.userID();
		return await DataService.get(`${ApiService.ZPChainApi}/stafflist/isOrderMember?userId=${userId}`, {}, { noShowErr: true });
	}
}
